declare global {
    interface Window {
      misha_loadmore_params: any;
      homeUrl: string;
      cookieController: Cookie[];
      contact: Contact[];
    }
}

import { Cookie } from "./cookie/cookie";
import { initHeader } from "./header/header";
import { initOffcanvas } from "./header/offcanvas";
import { initScroll } from "./header/scroll";
import { initCookie } from "./cookie/cookie";
import { Contact } from "./contact/contact";
import { initAnimation } from "./animation/animation";
import { initSidebar } from "./sidebar/sidebar";

initHeader();
initOffcanvas();
initScroll();
initCookie();
initAnimation();
initSidebar();
